import { Box, useTheme } from "@mui/material"
import { isMobileView } from "@sis/react-library";
import { PropsWithChildren } from "react"

interface ListAndDetailSamplesMultipleListHeadingContainerProps {
  widthOffset: number,
  heading?: React.ReactElement,
}

export const ListAndDetailSamplesMultipleListHeadingContainer = ({
  children, widthOffset, heading
}: PropsWithChildren<ListAndDetailSamplesMultipleListHeadingContainerProps>) => {

  const theme = useTheme();
  const isMobile = isMobileView();

  return (
    <Box
      sx={{
        position: isMobile ? undefined : 'relative',
        width: '100%',
      }}
    >
      <Box
        data-testid="container-style"
        sx={{
          height: 46,
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.grey[300]} `,
          position: isMobile ? undefined : 'absolute',
          top: isMobile ? undefined : '-14px',
          left: isMobile ? undefined : '-8px',
          width: isMobile ? undefined : `calc(100% + ${widthOffset}px)`,
          textAlign: 'left',
          padding: isMobile ? undefined : '8px'
        }}
      >
        <Box sx={{ padding: isMobile ? '8px' : undefined }}>
          {heading}
        </Box>
      </Box>
      {children}
    </Box>
  )
}
